import { useEffect, useMemo } from "react";
import { CanvasTexture, LinearFilter, SRGBColorSpace } from "three";

export function PlayerLabel({ label, isSelf }: { label: string; isSelf: boolean }) {
  const texture = useMemo(() => {
    const canvas = document.createElement("canvas");
    canvas.width = 256;
    canvas.height = 72;
    const context = canvas.getContext("2d");
    if (!context) return new CanvasTexture(canvas);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.font = `900 ${isSelf ? 34 : 29}px "DM Sans", sans-serif`;
    context.lineJoin = "round";
    context.lineWidth = 10;
    context.strokeStyle = "rgba(20, 58, 54, .84)";
    context.strokeText(label.slice(0, 16), 128, 37);
    context.fillStyle = isSelf ? "#fff5a8" : "#ffffff";
    context.fillText(label.slice(0, 16), 128, 37);
    const next = new CanvasTexture(canvas);
    next.colorSpace = SRGBColorSpace;
    next.minFilter = LinearFilter;
    next.magFilter = LinearFilter;
    next.needsUpdate = true;
    return next;
  }, [isSelf, label]);
  useEffect(() => () => texture.dispose(), [texture]);
  return (
    <sprite position={[0, 1.72, 0]} scale={[3.8, 1.08, 1]} renderOrder={20}>
      <spriteMaterial map={texture} transparent depthTest={false} depthWrite={false} toneMapped={false} />
    </sprite>
  );
}
